import React from 'react';
import { cn } from '@gik/core/utils/classnames';
import type { UIComponent } from '@gik/core/types/UI';
import { useRouter } from 'next/router';
import { Decoder } from '@gik/ui/Decoder';

export type SitemapItem = {
  url: string;
  title: string;
};

export type SitemapSectionViewProps = UIComponent & {
  items: SitemapItem[];
  title: string;
  prefix: string;
  baseUrl: string;
};

export const SitemapSectionView = ({ title, baseUrl, prefix, items, className }: SitemapSectionViewProps) => {
  const router = useRouter();

  return (
    <div>
      <h1>
        {title} ({items?.length})
      </h1>
      {router.pathname !== '/sitemap' ? (
        <div>
          <a href="/sitemap">← Back to Index</a>
        </div>
      ) : (
        <div>
          <a href="/">← Back to Home</a>
        </div>
      )}
      {items?.map(item => {
        // Check if item.url already includes the prefix to avoid duplication
        let relativePath;
        if (item.url.startsWith(prefix + '/') || item.url === prefix) {
          relativePath = item.url;
        } else {
          relativePath = `${prefix}/${item.url}`;
        }
        if (relativePath.startsWith('/')) {
          relativePath = relativePath.substring(1);
        }
        const url = baseUrl + relativePath;

        return (
          <div key={item.url}>
            <a href={url} className={cn('tw-text-black')} target="_blank" rel="noreferrer">
              <Decoder text={item.title} />
            </a>
            <br />
          </div>
        );
      })}
    </div>
  );
};
